export default __webpack_public_path__ + "static/media/spinner.e32f9ca8.svg";